
        import 'PriceBreakdownModal.a9503df.css-module'
        export default {"priceArticle":"priceArticle_PriceBreakdownModal_a9503df","priceExplained":"priceExplained_PriceBreakdownModal_a9503df","priceBreakdownModal":"priceBreakdownModal_PriceBreakdownModal_a9503df"}
    